import { useCruises } from '@/features/world-map/hooks/use-cruises';
import classes from './cruises-help.module.css';

/**
 * @param {React.HTMLProps<HTMLDivElement>} props
 * @returns {React.JSX.Element | false}
 */
export function CruisesHelp(props) {
  const { totalRecords, isLoading } = useCruises();

  return (
    totalRecords === 0 &&
    !isLoading && (
      <div className={classes.cruisesHelp} {...props}>
        <div className={classes.shadow} />
        This area of the map does not have any cruises. Please use the map to navigate to another location to find
        itineraries
      </div>
    )
  );
}
